import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxonFormat' })
export class LuxonFormatPipe implements PipeTransform {
    /**
     * Format a Luxon DateTime.
     *
     * @param value           the DateTime to format
     * @param format          a Luxon format token (e.g., 'MM/dd/yyyy')
     * @param interpretAsUtc  if true, treat the wall-clock components of the
     *                        DateTime as if they were UTC, then display in the
     *                        browser's local timezone. Use this when the
     *                        backend serializes DateTime values without a "Z"
     *                        suffix but the value was stored as UTC — the
     *                        service-proxy parses it as local and shifts the
     *                        date by the browser's offset, so we have to
     *                        manually re-anchor as UTC for display parity
     *                        with the legacy app (which either sent a "Z"
     *                        suffix or rendered via moment with implicit UTC
     *                        handling).
     */
    transform(value: DateTime, format: string, interpretAsUtc: boolean = false) {
        if (!value) {
            return '';
        }

        if (interpretAsUtc) {
            const utc = DateTime.utc(
                value.year,
                value.month,
                value.day,
                value.hour,
                value.minute,
                value.second,
            );
            return utc.toLocal().toFormat(format);
        }

        // Convert to local before formatting so UTC-marked values from the
        // backend display in the user's timezone (matching legacy moment.format
        // semantics, which converts to local by default). If the DateTime is
        // already in local zone, toLocal() is a no-op.
        return value.toLocal().toFormat(format);
    }
}
